import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { ShiftBundlePill } from "./Pill";

interface ShiftBundleFooterProps {
  requiredShiftCount: number;
  totalPayInMinorUnits: number | undefined;
}

export function ShiftBundleFooter(props: ShiftBundleFooterProps) {
  const { requiredShiftCount, totalPayInMinorUnits } = props;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ paddingX: 5, paddingY: 4 }}
    >
      <ShiftBundlePill shiftCount={requiredShiftCount} />
      {isDefined(totalPayInMinorUnits) && (
        <Text semibold variant="body1" sx={{ whiteSpace: "nowrap" }}>
          <Text inline variant="body1" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
            Up to{" "}
          </Text>
          {formatCentsAsUsd(totalPayInMinorUnits)}
        </Text>
      )}
    </Stack>
  );
}
